import { createRoot } from 'react-dom/client';
import { RootProvider } from './_shared/context/root-provider.js';
import { App } from './app/index.js';

createRoot(document.getElementById('root')!).render(
    <RootProvider>
        <App />
    </RootProvider>
);
